import React, { useEffect } from "react"
import { AppCrudTable } from "@components"
import { useAdminListTable, useManageEnabledUsers } from "Pages/Admin/Users/@hooks"
import { Skeleton } from "@mui/material"
import { actionsColumn, companyColumn, createdColumn, disabledColumn, emailColumn, nameColumn } from "Pages/Admin/Users/Table/@columns"
import { tableData } from "Pages/Admin/Users/@signals"
import enabledColumn from "Pages/Admin/Users/Table/@columns/enabled"
import MultipleUserSelect from "Pages/Admin/Users/Table/MultipleSelect"
import AdminUsersTableToolbar from "Pages/Admin/Users/Table/Toolbar"


export default function UserListTable() {
	const { getTableData, isTableLoading } = useAdminListTable()
	const { onChangeEnabled } = useManageEnabledUsers()

	useEffect(() => {
		getTableData()
	}, [])

	if (isTableLoading) return <Skeleton variant="rectangular" height={500}/>

	return <AppCrudTable
		title="Users List"
		data={tableData.value}
		options={{
			selectableRows: 'multiple',
			customToolbar: () => <AdminUsersTableToolbar/>,
			customToolbarSelect: (selectedData, setSelectedRows) => <MultipleUserSelect
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}/>
		}}
		columns={[
			nameColumn(),
			emailColumn(),
			companyColumn(),
			// roleColumn(),
			...createdColumn(),
			...disabledColumn(),
			...enabledColumn(onChangeEnabled),
			actionsColumn()
		]}
	/>
}